// import { useEffect, useRef, useState } from "react";
// import { useDispatch, useStore } from "react-redux";
// import * as i from "../lib";
// import { notification, trimName } from "utils";
// import { getCurrentUser } from "redux/reducers/authReducers";
// import { axiosCall, getDeviceData } from "api/helpers";
// import { isEmpty, omit } from "lodash";
// import { registerStaffSchema, reinviteStaffSchema } from "utils/formSchema";

// const auth = i.getAuth();
// const auth2 = i.auth2;

// const url = (endpoint) => `${i.baseURL_ET}/auth/${endpoint}`;

// const teamEmail = "esetechdevteam@gmail.com";
// const esetechEmailExt = "esetech.com.ng";
// const kaapoEmailExt = "kaapo.ng";

// export const useAuthStateChanged = () => {
//   const dispatch = useDispatch();
//   const { profile } = useStore().getState();

//   useEffect(() => {
//     const unsubscribe = i.onAuthStateChanged(auth, (user) => {
//       if (user) {
//         const { uid, displayName, email, metadata, phoneNumber, photoURL } =
//           user;
//         dispatch(
//           getCurrentUser({
//             current_user: uid,
//             current_user_details: {
//               uid,
//               displayName,
//               email,
//               metadata,
//               phoneNumber,
//               photoURL,
//             },
//             isLoading: false,
//             isLoaded: true,
//           })
//         );
//       } else {
//         dispatch(
//           getCurrentUser({
//             current_user: null,
//             current_user_details: null,
//             isLoading: false,
//             isLoaded: true,
//           })
//         );
//       }
//     });

//     return () => {
//       unsubscribe();
//     };
//   }, [dispatch, profile]);
// };

// const loginAuth = async (email, password, setIsLoading, setIsLoaded) => {
//   setIsLoading(true);
//   try {
//     await i.setPersistence(auth, i.browserSessionPersistence);

//     const [userCredential] = await Promise.all([
//       i.signInWithEmailAndPassword(auth, email, password),
//       i.signInWithEmailAndPassword(auth2, email, password),
//     ]);

//     const user = userCredential.user;

//     // console.log(user?.uid, "userCredential.user");

//     await Promise.all([
//       i.updateDoc(i.doc(i.db, "staff", user.uid), {
//         lastLoginAt: i.serverTimestamp(),
//       }),
//       i.updateDoc(i.doc(i.db2, "staff", user.uid), {
//         lastLoginAt: i.serverTimestamp(),
//       }),
//     ]);

//     setIsLoading(false);
//     setIsLoaded(true);
//     return user?.uid;
//   } catch (error) {
//     throw new Error(error.code);
//   }
// };

// // export const useLogin = () => {
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [isLoaded, setIsLoaded] = useState(false);
// //   const [error, setError] = useState(false);

// //   // const navigate = useNavigate();

// //   const login = async (email, password) => {
// //     try {
// //       if (!email.includes(esetechEmailExt) && !email.includes(kaapoEmailExt)) {
// //         throw new Error("Reach out to the admin");
// //       }

// //       setIsLoaded(true);

// //       await loginAuth(email, password, setIsLoading, setIsLoaded);
// //     } catch (error) {
// //       console.log(error, "error");
// //       let message;
// //       if (error.response) {
// //         const messageRes = error.response?.data?.error;
// //         switch (messageRes) {
// //           case "There is no user record corresponding to the provided identifier.":
// //             message = "User does not exist!";
// //             break;
// //           default:
// //             message = messageRes;
// //         }
// //       } else {
// //         // const { code } = error;
// //         const code = error?.code || error?.message;
// //         switch (code) {
// //           case "auth/too-many-requests":
// //             message =
// //               "Access to this account has been temporarily disabled due to many failed login attempts. Try again later.";
// //             break;
// //           case "auth/wrong-password":
// //             message = "Invalid email/password.";
// //             break;
// //           case "auth/user-not-found":
// //             message = "Invalid email/password.";
// //             break;
// //           default:
// //             message = "Unable to log in. Try again later.";
// //         }
// //       }
// //       // console.log(error, error.message, error.code);
// //       setIsLoading(false);
// //       setIsLoaded(true);
// //       setError(true);
// //       notification("danger", message, "error");
// //     }
// //   };

// //   return [isLoading, isLoaded, error, login];
// // };

// export const useRegisterStaff = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [error, setError] = useState(false);

//   useEffect(() => {
//     setTimeout(() => {
//       setIsLoaded(false);
//     }, 500);
//   }, [isLoaded]);

//   const register = async (values) => {
//     const { email, firstName, lastName } = values;

//     const avatarUrl =
//       "https://firebasestorage.googleapis.com/v0/b/kaapo-app.appspot.com/o/avatar_esetech.png?alt=media&token=21589ce3-5c9f-466b-934c-80f6db590af6";

//     try {
//       setIsLoading(true);
//       if (isEmpty(values)) {
//         throw new Error("Invalid Params");
//       }
//       await registerStaffSchema.validate(values);

//       if (!email.includes(kaapoEmailExt)) {
//         throw new Error("Reach out to the admin");
//       }

//       const concatNames = `${firstName} ${lastName}`;

//       const valuesFormat = {
//         ...omit(values, ["firstName", "lastName"]),
//         displayName: trimName(concatNames),
//         accountStatus: "enabled",
//         disabled: false,
//         status: "verified",
//         type: "staff",
//         avatarUrl,
//       };

//       const configRegisterUser = { values: valuesFormat };

//       await axiosCall(url("register_staff"), configRegisterUser, true);

//       setIsLoading(false);
//       setIsLoaded(true);
//       notification("success", "Staff Successfully invited!");
//     } catch (error) {
//       let message = JSON.stringify(error?.message || error);

//       // console.log(error?.message, error);
//       setIsLoading(false);
//       setError(true);
//       notification("danger", message, "error");
//     }
//   };

//   return [isLoading, isLoaded, register];
// };

// export const useReInviteStaff = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [error, setError] = useState(false);

//   useEffect(() => {
//     setTimeout(() => {
//       setIsLoaded(false);
//     }, 500);
//   }, [isLoaded]);

//   const reInvite = async (values) => {
//     const { email, newEmail } = values;

//     try {
//       setIsLoading(true);
//       if (isEmpty(values)) {
//         throw new Error("Invalid Params");
//       }
//       await reinviteStaffSchema.validate(values);

//       if (!email.includes(kaapoEmailExt) && !newEmail.includes(kaapoEmailExt)) {
//         throw new Error("Reach out to the admin");
//       }

//       const valuesFormat = {
//         ...values,
//       };

//       const configRegisterUser = { values: valuesFormat };

//       await axiosCall(url("reinvite_staff"), configRegisterUser, true);

//       setIsLoading(false);
//       setIsLoaded(true);
//       notification("success", "Staff Successfully invited!");
//     } catch (error) {
//       let message = JSON.stringify(error?.message || error);

//       //console.log(error?.message, error);
//       setIsLoading(false);
//       setError(true);
//       notification("danger", message, "error");
//     }
//   };

//   return [isLoading, isLoaded, reInvite];
// };

// const invalidateOtherSessions = async (staffId, baseDeviceHash) => {
//   try {
//     const response = await axiosCall(
//       url("invalidate_sessions"),
//       {
//         staffId,
//         baseDeviceHash,
//       },
//       true
//     );

//     if (response.data?.success) {
//       notification(
//         "info",
//         "Previous sessions on this device have been logged out",
//         "info"
//       );
//     }
//   } catch (error) {
//     console.error("Error invalidating other sessions:", error);
//     notification(
//       "warning",
//       "Unable to manage other sessions. You may need to log out manually from other devices.",
//       "warning"
//     );
//     throw error;
//   }
// };

// export const useLogin = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [error, setError] = useState(false);
//   const isRegisteringDevice = useRef(false);
//   const justLoggedIn = useRef(false);

//   useEffect(() => {
//     const unsubscribe = auth.onIdTokenChanged(async (user) => {
//       if (user && !isRegisteringDevice.current) {
//         try {
//           if (justLoggedIn.current) {
//             justLoggedIn.current = false;
//             return;
//           }

//           const tokenResult = await user.getIdTokenResult(true);
//           const { sessionToken, currentDevice } = tokenResult.claims;

//           // Skip if no device info in claims (fresh login)
//           if (!currentDevice || !sessionToken) return;

//           const devicesQuery = i.query(
//             i.collection(i.db, "staffDevices"),
//             i.where("baseDeviceHash", "==", currentDevice),
//             i.where("isActive", "==", true)
//           );

//           const deviceSnapshot = await i.getDocs(devicesQuery);

//           // Sign out if there's an active device AND its session token doesn't match
//           if (
//             !deviceSnapshot.empty &&
//             deviceSnapshot.docs[0].data().sessionToken !== sessionToken
//           ) {
//             await auth.signOut();
//             notification(
//               "info",
//               `There is an active session on this device.
//                Please log out the session and log in again.`,
//               "info"
//             );
//           }
//         } catch (error) {
//           console.error("Session validation error:", error);
//         }
//       }
//     });

//     return () => unsubscribe();
//   }, []);

//   const checkActiveSession = async (userId) => {
//     console.log(userId, "checkActiveSession userId");
//     try {
//       let unsub;
//       const devicesQuery = i.query(
//         i.collection(i.db, "staffDevices"),
//         i.where("currentUserId", "==", userId),
//         i.where("isActive", "==", true)
//       );

//       const devicesSnapshot = await i.getDocs(devicesQuery);

//       console.log(devicesSnapshot.docs[0], "devicesSnapshot");

//       return {
//         isActive: !devicesSnapshot.empty,
//         devices: devicesSnapshot.docs[0].data(),
//       };
//     } catch (error) {
//       console.error("Error checking active session:", error);
//       throw error;
//     }
//   };

//   const registerDevice = async (userId) => {
//     try {
//       isRegisteringDevice.current = true;
//       const deviceInfo = getDeviceData();
//       const valuesFormat = {
//         ...deviceInfo,
//         staffId: userId,
//         userId,
//         action: "add",
//       };

//       const config = { values: valuesFormat };
//       const response = await axiosCall(url("register_device"), config, true);

//       console.log(response.data?.data, "register device response");

//       if (response.data?.data?.requiresInvalidation) {
//         await invalidateOtherSessions(
//           userId,
//           response?.data?.data?.baseDeviceHash
//         );
//       }

//       await auth.currentUser?.getIdToken(true);
//       return response.data.data;
//     } catch (error) {
//       console.error("Device registration error:", error);
//       notification(
//         "warning",
//         "Device registration needs attention. Please contact support if issues persist.",
//         "warning"
//       );
//       throw error;
//     } finally {
//       isRegisteringDevice.current = false;
//     }
//   };

//   const login = async (email, password) => {
//     try {
//       if (!email.includes(esetechEmailExt) && !email.includes(kaapoEmailExt)) {
//         throw new Error("Please use your company email address");
//       }

//       setIsLoading(true);
//       setIsLoaded(false);
//       setError(false);

//       // First authenticate the user
//       const userCredential = await loginAuth(
//         email,
//         password,
//         setIsLoading,
//         setIsLoaded
//       );

//       if (userCredential) {
//         // Check for active sessions
//         const hasActiveSession = await checkActiveSession(userCredential);

//         if (hasActiveSession.isActive) {
//           // await auth.signOut();

//           console.log(hasActiveSession.devices, "hasActiveSession.devices");

//           const currentUser = auth.currentUser;

//           const tokenResult = await currentUser.getIdTokenResult(true);
//           const { sessionToken, currentDevice } = tokenResult.claims;

//           const valuesFormat = {
//             user: currentUser.uid,
//             device: currentDevice,
//           };

//           const config = { values: valuesFormat };
//           const response = await axiosCall(
//             url("end_device_session"),
//             config,
//             true
//           );

//           console.log(response.data, "end_device_session response");

//           throw new Error(
//             `You have an active session.
//             Please log out first and try again, or reach out to the tech team.`
//           );
//         }

//         isRegisteringDevice.current = true;
//         justLoggedIn.current = true;
//         await registerDevice(userCredential);
//         setIsLoaded(true);
//         notification("success", "Login successful", "success");
//       }
//     } catch (error) {
//       console.error("Login error:", error);

//       let message;
//       if (error.response) {
//         const messageRes = error.response?.data?.error;
//         switch (messageRes) {
//           case "There is no user record corresponding to the provided identifier.":
//             message = "User does not exist!";
//             break;
//           case "Unauthorized device registration attempt":
//             message = "Device registration failed. Please contact support.";
//             break;
//           default:
//             message = messageRes;
//         }
//       } else {
//         const code = error?.code || error?.message;
//         switch (code) {
//           case "auth/too-many-requests":
//             message = "Too many failed attempts. Please try again later.";
//             break;
//           case "auth/wrong-password":
//           case "auth/user-not-found":
//             message = "Invalid email or password.";
//             break;
//           default:
//             message = error.message || "Login failed. Please try again.";
//         }
//       }
//       setError(true);
//       notification("danger", message, "error");
//     } finally {
//       setIsLoading(false);
//       setIsLoaded(true);
//       isRegisteringDevice.current = false;
//     }
//   };

//   return [isLoading, isLoaded, error, login];
// };

// export const useLogout = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [error, setError] = useState(false);

//   const logout = async () => {
//     setIsLoading(true);
//     setError(false);

//     try {
//       const currentUser = auth.currentUser;
//       if (!currentUser) {
//         throw new Error("No authenticated user");
//       }

//       const tokenResult = await currentUser.getIdTokenResult(true);
//       const { sessionToken, currentDevice } = tokenResult.claims;

//       const valuesFormat = {
//         user: currentUser.uid,
//         device: currentDevice,
//       };

//       const config = { values: valuesFormat };
//       const response = await axiosCall(url("end_device_session"), config, true);

//       if (response.data?.success) {
//         await Promise.all([i.signOut(auth), i.signOut(auth2)]);
//         setIsLoaded(true);
//       } else {
//         throw new Error("Server failed to end session");
//       }
//     } catch (error) {
//       setError(true);
//       notification(
//         "warning",
//         "Failed to end session. Please try again.",
//         "warning"
//       );
//       console.error("Signout error:", error);
//     } finally {
//       setIsLoading(false);
//       setIsLoaded(true);
//     }
//   };

//   return [isLoading, isLoaded, error, logout];
// };

// // export const useLogout = () => {
// //   const [isLoading, setIsLoading] = useState(false);
// //   const [isLoaded, setIsLoaded] = useState(false);
// //   const [error, setError] = useState(false);

// //   const logout = async (user) => {
// //     setIsLoading(true);

// //     const valuesFormat = {
// //       user,
// //     };

// //     const config = { values: valuesFormat };

// //     try {
// //       // Create a promise that resolves when the auth state changes
// //       const authStatePromise = new Promise((resolve) => {
// //         const unsubscribe = i.onAuthStateChanged(auth, async (currentUser) => {
// //           if (!currentUser) {
// //             try {
// //               await axiosCall(url("end_device_session"), config, true);
// //             } catch (error) {
// //               console.error("API call error:", error);
// //               setError(true);
// //             } finally {
// //               unsubscribe();
// //               resolve();
// //             }
// //           }
// //         });
// //       });

// //       // Perform signouts and wait for auth state change
// //       await Promise.all([i.signOut(auth), i.signOut(auth2), authStatePromise]);

// //       setIsLoaded(true);
// //     } catch (error) {
// //       setError(true);
// //       console.error("Signout error:", error);
// //     } finally {
// //       setIsLoading(false);
// //     }
// //   };

// //   return [isLoading, isLoaded, error, logout];
// // };

// export const sendVerifyOtp = async () => {
//   return new Promise(async (resolve, reject) => {
//     try {
//       const valuesFormat = {
//         email: teamEmail,
//         username: "Dev Team",
//         isVerify: false,
//       };
//       const config = { values: valuesFormat };

//       await axiosCall(url("verify_email_otp"), config, true);

//       return resolve(true);
//     } catch (error) {
//       let message = error?.message || error;

//       //console.log(message);

//       return reject(message);
//     }
//   });
// };

// export const checkVerifyOtp = (code) => {
//   return new Promise(async (resolve, reject) => {
//     try {
//       const valuesFormat = {
//         email: teamEmail,
//         code,
//         isVerify: false,
//       };
//       const config = { values: valuesFormat };

//       await axiosCall(url("check_email_otp"), config, true);
//       return resolve(true);
//     } catch (error) {
//       let message = error?.message || error;

//       // console.log(error?.message, error);
//       return reject(message);
//     }
//   });
// };

// export const validatePassword = async (password) => {
//   try {
//     const user = auth.currentUser;
//     if (!user) {
//       throw new Error("No user is currently signed in.");
//     }
//     const credential = i.EmailAuthProvider.credential(user.email, password);

//     await i.reauthenticateWithCredential(user, credential);

//     return true;
//   } catch (error) {
//     const msg = error.code;
//     notification(
//       "danger",
//       msg === "auth/wrong-password"
//         ? "Incorrect Password"
//         : msg === "auth/too-many-requests"
//         ? "Too many failed password verify attempts. Try again later"
//         : "An error occured. Try again later!",
//       "error"
//     );
//     return false;
//   }
// };

// export const useUpdateDevice = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [error, setError] = useState(null);

//   const fetchDeviceInfo = async (baseDeviceHash) => {
//     if (!baseDeviceHash) {
//       console.log("No baseDeviceHash provided");
//       return null;
//     }

//     try {
//       const q = i.query(
//         i.collection(i.db, "staffDevices"),
//         i.where("baseDeviceHash", "==", baseDeviceHash)
//       );
//       const querySnapshot = await i.getDocs(q);
//       const deviceData = querySnapshot.docs[0]?.data();
//       return deviceData;
//     } catch (error) {
//       console.error("Error fetching device info:", error);
//       return null;
//     }
//   };

//   const updateDevice = async (deviceId, deviceData, userId) => {
//     try {
//       setIsLoading(true);
//       setError(null);

//       const existingDeviceData = await fetchDeviceInfo(
//         deviceData.baseDeviceHash
//       );

//       const valuesFormat = {
//         ...deviceData,
//         userId,
//         staffId: userId,
//         action: "update",
//         createdAt: i.serverTimestamp(),
//         browserName: existingDeviceData?.browserName || "",
//         userAgent: existingDeviceData?.userAgent || "",
//         vendor: existingDeviceData?.vendor || "",
//       };

//       const config = { values: valuesFormat };

//       const response = await axiosCall(
//         url("register_device", "esetech"),
//         config,
//         true,
//         "esetech"
//       );

//       notification("success", "Device updated successfully");
//       setIsLoaded(true);
//       return response;
//     } catch (error) {
//       console.error("Device update error:", error);
//       setError(error);
//       notification("danger", "Failed to update device");
//       return false;
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return [isLoading, isLoaded, fetchDeviceInfo, updateDevice];
// };

import { useEffect, useRef, useState } from "react";
import { useDispatch, useStore } from "react-redux";
import * as i from "../lib";
import { notification, trimName } from "utils";
import { getCurrentUser } from "redux/reducers/authReducers";
import { axiosCall, getDeviceData } from "api/helpers";
import { isEmpty, omit } from "lodash";
import { registerStaffSchema, reinviteStaffSchema } from "utils/formSchema";

const auth = i.getAuth();
const auth2 = i.auth2;

const url = (endpoint) => `${i.baseURL_ET}/auth/${endpoint}`;

const teamEmail = "esetechdevteam@gmail.com";
const esetechEmailExt = "esetech.com.ng";
const kaapoEmailExt = "kaapo.ng";

export const useAuthStateChanged = () => {
  const dispatch = useDispatch();
  const { profile } = useStore().getState();

  useEffect(() => {
    const unsubscribe = i.onAuthStateChanged(auth, (user) => {
      if (user) {
        const { uid, displayName, email, metadata, phoneNumber, photoURL } =
          user;
        dispatch(
          getCurrentUser({
            current_user: uid,
            current_user_details: {
              uid,
              displayName,
              email,
              metadata,
              phoneNumber,
              photoURL,
            },
            isLoading: false,
            isLoaded: true,
          }),
        );
      } else {
        dispatch(
          getCurrentUser({
            current_user: null,
            current_user_details: null,
            isLoading: false,
            isLoaded: true,
          }),
        );
      }
    });

    return () => {
      unsubscribe();
    };
  }, [dispatch, profile]);
};

const loginAuth = async (email, password, setIsLoading, setIsLoaded) => {
  setIsLoading(true);
  try {
    await i.setPersistence(auth, i.browserSessionPersistence);

    const [userCredential] = await Promise.all([
      i.signInWithEmailAndPassword(auth, email, password),
      i.signInWithEmailAndPassword(auth2, email, password),
    ]);

    const user = userCredential.user;

    // console.log(user?.uid, "userCredential.user");

    await Promise.all([
      i.updateDoc(i.doc(i.db, "staff", user.uid), {
        lastLoginAt: i.serverTimestamp(),
      }),
      i.updateDoc(i.doc(i.db2, "staff", user.uid), {
        lastLoginAt: i.serverTimestamp(),
      }),
    ]);

    setIsLoading(false);
    setIsLoaded(true);
    return user?.uid;
  } catch (error) {
    throw new Error(error.code);
  }
};

// export const useLogin = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [error, setError] = useState(false);

//   // const navigate = useNavigate();

//   const login = async (email, password) => {
//     try {
//       if (!email.includes(esetechEmailExt) && !email.includes(kaapoEmailExt)) {
//         throw new Error("Reach out to the admin");
//       }

//       setIsLoaded(true);

//       await loginAuth(email, password, setIsLoading, setIsLoaded);
//     } catch (error) {
//       console.log(error, "error");
//       let message;
//       if (error.response) {
//         const messageRes = error.response?.data?.error;
//         switch (messageRes) {
//           case "There is no user record corresponding to the provided identifier.":
//             message = "User does not exist!";
//             break;
//           default:
//             message = messageRes;
//         }
//       } else {
//         // const { code } = error;
//         const code = error?.code || error?.message;
//         switch (code) {
//           case "auth/too-many-requests":
//             message =
//               "Access to this account has been temporarily disabled due to many failed login attempts. Try again later.";
//             break;
//           case "auth/wrong-password":
//             message = "Invalid email/password.";
//             break;
//           case "auth/user-not-found":
//             message = "Invalid email/password.";
//             break;
//           default:
//             message = "Unable to log in. Try again later.";
//         }
//       }
//       // console.log(error, error.message, error.code);
//       setIsLoading(false);
//       setIsLoaded(true);
//       setError(true);
//       notification("danger", message, "error");
//     }
//   };

//   return [isLoading, isLoaded, error, login];
// };

export const useRegisterStaff = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsLoaded(false);
    }, 500);
  }, [isLoaded]);

  const register = async (values) => {
    const { email, firstName, lastName } = values;

    const avatarUrl =
      "https://firebasestorage.googleapis.com/v0/b/kaapo-app.appspot.com/o/avatar_esetech.png?alt=media&token=21589ce3-5c9f-466b-934c-80f6db590af6";

    try {
      setIsLoading(true);
      if (isEmpty(values)) {
        throw new Error("Invalid Params");
      }
      await registerStaffSchema.validate(values);

      if (!email.includes(kaapoEmailExt)) {
        throw new Error("Reach out to the admin");
      }

      const concatNames = `${firstName} ${lastName}`;

      const valuesFormat = {
        ...omit(values, ["firstName", "lastName"]),
        displayName: trimName(concatNames),
        accountStatus: "enabled",
        disabled: false,
        status: "verified",
        type: "staff",
        avatarUrl,
      };

      const configRegisterUser = { values: valuesFormat };

      await axiosCall(url("register_staff"), configRegisterUser, true);

      setIsLoading(false);
      setIsLoaded(true);
      notification("success", "Staff Successfully invited!");
    } catch (error) {
      let message = JSON.stringify(error?.message || error);

      // console.log(error?.message, error);
      setIsLoading(false);
      setError(true);
      notification("danger", message, "error");
    }
  };

  return [isLoading, isLoaded, register];
};

export const useReInviteStaff = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsLoaded(false);
    }, 500);
  }, [isLoaded]);

  const reInvite = async (values) => {
    const { email, newEmail } = values;

    try {
      setIsLoading(true);
      if (isEmpty(values)) {
        throw new Error("Invalid Params");
      }
      await reinviteStaffSchema.validate(values);

      if (!email.includes(kaapoEmailExt) && !newEmail.includes(kaapoEmailExt)) {
        throw new Error("Reach out to the admin");
      }

      const valuesFormat = {
        ...values,
      };

      const configRegisterUser = { values: valuesFormat };

      await axiosCall(url("reinvite_staff"), configRegisterUser, true);

      setIsLoading(false);
      setIsLoaded(true);
      notification("success", "Staff Successfully invited!");
    } catch (error) {
      let message = JSON.stringify(error?.message || error);

      //console.log(error?.message, error);
      setIsLoading(false);
      setError(true);
      notification("danger", message, "error");
    }
  };

  return [isLoading, isLoaded, reInvite];
};

const invalidateOtherSessions = async (staffId, baseDeviceHash) => {
  try {
    const response = await axiosCall(
      url("invalidate_sessions"),
      {
        staffId,
        baseDeviceHash,
      },
      true,
    );

    if (response.data?.success) {
      notification(
        "info",
        "Previous sessions on this device have been logged out",
        "info",
      );
    }
  } catch (error) {
    console.error("Error invalidating other sessions:", error);
    notification(
      "warning",
      "Unable to manage other sessions. You may need to log out manually from other devices.",
      "warning",
    );
    throw error;
  }
};

export const useLogin = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);
  const isRegisteringDevice = useRef(false);
  const justLoggedIn = useRef(false);

  useEffect(() => {
    const unsubscribe = auth.onIdTokenChanged(async (user) => {
      if (user && !isRegisteringDevice.current) {
        try {
          if (justLoggedIn.current) {
            justLoggedIn.current = false;
            return;
          }

          const tokenResult = await user.getIdTokenResult(true);
          const { sessionToken, currentDevice } = tokenResult.claims;

          // Skip if no device info in claims (fresh login)
          if (!currentDevice || !sessionToken) return;

          const devicesQuery = i.query(
            i.collection(i.db, "staffDevices"),
            i.where("baseDeviceHash", "==", currentDevice),
            i.where("isActive", "==", true),
          );

          const deviceSnapshot = await i.getDocs(devicesQuery);

          // Sign out if there's an active device AND its session token doesn't match
          if (
            !deviceSnapshot.empty &&
            deviceSnapshot.docs[0].data().sessionToken !== sessionToken
          ) {
            await auth.signOut();
            notification(
              "info",
              `There is an active session on this device. 
               Please log out the session and log in again.`,
              "info",
            );
          }
        } catch (error) {
          console.error("Session validation error:", error);
        }
      }
    });

    return () => unsubscribe();
  }, []);

  const checkActiveSession = async (userId) => {
    try {
      const devicesQuery = i.query(
        i.collection(i.db, "staffDevices"),
        i.where("currentUserId", "==", userId),
        i.where("isActive", "==", true),
      );

      const devicesSnapshot = await i.getDocs(devicesQuery);
      return !devicesSnapshot.empty;
    } catch (error) {
      console.error("Error checking active session:", error);
      throw error;
    }
  };

  const registerDevice = async (userId) => {
    try {
      isRegisteringDevice.current = true;
      const deviceInfo = getDeviceData();
      const valuesFormat = {
        ...deviceInfo,
        staffId: userId,
        userId,
        action: "add",
      };

      const config = { values: valuesFormat };
      const response = await axiosCall(url("register_device"), config, true);

      if (response.data?.data?.requiresInvalidation) {
        await invalidateOtherSessions(
          userId,
          response?.data?.data?.baseDeviceHash,
        );
      }

      await auth.currentUser?.getIdToken(true);
      return response.data.data;
    } catch (error) {
      console.error("Device registration error:", error);
      notification(
        "warning",
        "Device registration needs attention. Please contact support if issues persist.",
        "warning",
      );
      throw error;
    } finally {
      isRegisteringDevice.current = false;
    }
  };

  const login = async (email, password) => {
    try {
      if (!email.includes(esetechEmailExt) && !email.includes(kaapoEmailExt)) {
        throw new Error("Please use your company email address");
      }

      setIsLoading(true);
      setIsLoaded(false);
      setError(false);

      // First authenticate the user
      const userCredential = await loginAuth(
        email,
        password,
        setIsLoading,
        setIsLoaded,
      );

      if (userCredential) {
        // Check for active sessions
        const hasActiveSession = await checkActiveSession(userCredential);

        if (hasActiveSession) {
          await auth.signOut();
          throw new Error(
            `You have an active session. 
            Please log out first and try again, or reach out to the tech team.`,
          );
        }

        isRegisteringDevice.current = true;
        justLoggedIn.current = true;
        await registerDevice(userCredential);
        setIsLoaded(true);
        notification("success", "Login successful", "success");
      }
    } catch (error) {
      console.error("Login error:", error);

      let message;
      if (error.response) {
        const messageRes = error.response?.data?.error;
        switch (messageRes) {
          case "There is no user record corresponding to the provided identifier.":
            message = "User does not exist!";
            break;
          case "Unauthorized device registration attempt":
            message = "Device registration failed. Please contact support.";
            break;
          default:
            message = messageRes;
        }
      } else {
        const code = error?.code || error?.message;
        switch (code) {
          case "auth/too-many-requests":
            message = "Too many failed attempts. Please try again later.";
            break;
          case "auth/wrong-password":
          case "auth/user-not-found":
            message = "Invalid email or password.";
            break;
          default:
            message = error.message || "Login failed. Please try again.";
        }
      }
      setError(true);
      notification("danger", message, "error");
    } finally {
      setIsLoading(false);
      setIsLoaded(true);
      isRegisteringDevice.current = false;
    }
  };

  return [isLoading, isLoaded, error, login];
};

export const useLogout = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);

  const logout = async () => {
    setIsLoading(true);
    setError(false);

    try {
      const currentUser = auth.currentUser;
      if (!currentUser) {
        throw new Error("No authenticated user");
      }

      const tokenResult = await currentUser.getIdTokenResult(true);
      const { sessionToken, currentDevice } = tokenResult.claims;

      const valuesFormat = {
        user: currentUser.uid,
        device: currentDevice,
      };

      const config = { values: valuesFormat };
      const response = await axiosCall(url("end_device_session"), config, true);

      if (response.data?.success) {
        await Promise.all([i.signOut(auth), i.signOut(auth2)]);
        setIsLoaded(true);
      } else {
        throw new Error("Server failed to end session");
      }
    } catch (error) {
      setError(true);
      notification(
        "warning",
        "Failed to end session. Please try again.",
        "warning",
      );
      console.error("Signout error:", error);
    } finally {
      setIsLoading(false);
      setIsLoaded(true);
    }
  };

  return [isLoading, isLoaded, error, logout];
};

// export const useLogout = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [error, setError] = useState(false);

//   const logout = async (user) => {
//     setIsLoading(true);

//     const valuesFormat = {
//       user,
//     };

//     const config = { values: valuesFormat };

//     try {
//       // Create a promise that resolves when the auth state changes
//       const authStatePromise = new Promise((resolve) => {
//         const unsubscribe = i.onAuthStateChanged(auth, async (currentUser) => {
//           if (!currentUser) {
//             try {
//               await axiosCall(url("end_device_session"), config, true);
//             } catch (error) {
//               console.error("API call error:", error);
//               setError(true);
//             } finally {
//               unsubscribe();
//               resolve();
//             }
//           }
//         });
//       });

//       // Perform signouts and wait for auth state change
//       await Promise.all([i.signOut(auth), i.signOut(auth2), authStatePromise]);

//       setIsLoaded(true);
//     } catch (error) {
//       setError(true);
//       console.error("Signout error:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return [isLoading, isLoaded, error, logout];
// };

export const sendVerifyOtp = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const valuesFormat = {
        email: teamEmail,
        username: "Dev Team",
        isVerify: false,
      };
      const config = { values: valuesFormat };

      await axiosCall(url("verify_email_otp"), config, true);

      return resolve(true);
    } catch (error) {
      let message = error?.message || error;

      //console.log(message);

      return reject(message);
    }
  });
};

export const checkVerifyOtp = (code) => {
  return new Promise(async (resolve, reject) => {
    try {
      const valuesFormat = {
        email: teamEmail,
        code,
        isVerify: false,
      };
      const config = { values: valuesFormat };

      await axiosCall(url("check_email_otp"), config, true);
      return resolve(true);
    } catch (error) {
      let message = error?.message || error;

      // console.log(error?.message, error);
      return reject(message);
    }
  });
};

export const validatePassword = async (password) => {
  try {
    const user = auth.currentUser;
    if (!user) {
      throw new Error("No user is currently signed in.");
    }
    const credential = i.EmailAuthProvider.credential(user.email, password);

    await i.reauthenticateWithCredential(user, credential);

    return true;
  } catch (error) {
    const msg = error.code;
    notification(
      "danger",
      msg === "auth/wrong-password"
        ? "Incorrect Password"
        : msg === "auth/too-many-requests"
        ? "Too many failed password verify attempts. Try again later"
        : "An error occured. Try again later!",
      "error",
    );
    return false;
  }
};

export const useUpdateDevice = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  const fetchDeviceInfo = async (baseDeviceHash) => {
    if (!baseDeviceHash) {
      console.log("No baseDeviceHash provided");
      return null;
    }

    try {
      const q = i.query(
        i.collection(i.db, "staffDevices"),
        i.where("baseDeviceHash", "==", baseDeviceHash),
      );
      const querySnapshot = await i.getDocs(q);
      const deviceData = querySnapshot.docs[0]?.data();
      return deviceData;
    } catch (error) {
      console.error("Error fetching device info:", error);
      return null;
    }
  };

  const updateDevice = async (deviceId, deviceData, userId) => {
    try {
      setIsLoading(true);
      setError(null);

      const existingDeviceData = await fetchDeviceInfo(
        deviceData.baseDeviceHash,
      );

      const valuesFormat = {
        ...deviceData,
        userId,
        staffId: userId,
        action: "update",
        createdAt: i.serverTimestamp(),
        browserName: existingDeviceData?.browserName || "",
        userAgent: existingDeviceData?.userAgent || "",
        vendor: existingDeviceData?.vendor || "",
      };

      const config = { values: valuesFormat };

      const response = await axiosCall(
        url("register_device", "esetech"),
        config,
        true,
        "esetech",
      );

      notification("success", "Device updated successfully");
      setIsLoaded(true);
      return response;
    } catch (error) {
      console.error("Device update error:", error);
      setError(error);
      notification("danger", "Failed to update device");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return [isLoading, isLoaded, fetchDeviceInfo, updateDevice];
};
